export default function getName(name) {
  return this.$store.getters.getLabelByName(name);
}
